import { LitElement, css, html } from 'lit';
import { customElement, property, query, state } from 'lit/decorators';

import { Menu } from '@material/mwc-menu';
import { StateController } from '../../helpers/state/state-management/state-controller';
import accountInfo from '../../helpers/state/account-info';
import { logWithAmplitude } from '../../helpers/api/api';
import { openChatWindow } from '../../helpers/intercom';

@customElement('help-menu')
export class HelpMenu extends LitElement {
    static amplitude_callsite: string = 'Help Menu';

    @query('#cornerMenu')
    cornerMenu!: Menu;

    @query('#menuConnect')
    menuConnect!: HTMLDivElement;

    @property({ type: String })
    type: string = 'backpack';

    @state()
    mini: boolean = false;

    private readonly bindAccountState = new StateController(this, accountInfo);

    async firstUpdated() {
        await this.startup();
    }

    private async startup() {
        this.cornerMenu.anchor = this.menuConnect;
    }

    protected render() {
        // const xPos = 0;
        // const yPos = 0;

        return html`
            <div style="position: relative">
                <form-button variant="navbutton" id="menuConnect"
                    size="xs"
                    class="desktopOnly"
                    @click="${() => { this.cornerMenu.open = true; this.dispatchEvent(new CustomEvent('menu-opened')); }}">
                        <mwc-icon
                            class="headerIcon"
                        >question_mark</mwc-icon>
                    ${this.mini ? '' : 'Help'}
                </form-button>
                <mwc-menu id="cornerMenu">
					<mwc-list-item @click="${this.learnClick}">
                        <div class="flexContainer">
                            <mwc-icon class="menuIcon">local_library</mwc-icon>
                            <span>Help Docs</span>
                        </div>
                    </mwc-list-item>
                    <mwc-list-item @click="${this.blogClick}">
                        <div class="flexContainer">
                            <mwc-icon class="menuIcon">newspaper</mwc-icon>
                            <span>Visit our Blog</span>
                        </div>
                    </mwc-list-item>
                    <mwc-list-item @click="${this.scheduleDemoClick}">
                        <div class="flexContainer">
                            <mwc-icon class="menuIcon">schedule</mwc-icon>
                            <span>Schedule Demo or Walkthrough</span>
                        </div>
                    </mwc-list-item>
                    <mwc-list-item @click="${this.submitFeatureRequestClick}">
                        <div class="flexContainer">
                            <mwc-icon class="menuIcon">chat_bubble_outline</mwc-icon>
                            <span>Feature Request</span>
                        </div>
                    </mwc-list-item>
					<mwc-list-item @click="${openChatWindow}">
                        <div class="flexContainer">
                            <mwc-icon class="menuIcon">post_add</mwc-icon>
                            <span>Chat with Us</span>
                        </div>
                    </mwc-list-item>
					<mwc-list-item @click="${this.visitContactClick}">
                        <div class="flexContainer">
                            <mwc-icon class="menuIcon">mail_outline</mwc-icon>
                            <span>Email Us</span>
                        </div>
                    </mwc-list-item>
                </mwc-menu>
            </div>
        `;
    }

    static get styles() {
        return css`
            :host {
                --mdc-menu-min-width: min(100vw,150px);
                --mdc-menu-max-width: 200px;
                --mdc-typography-subtitle1-font-size: 12px;
                --mdc-menu-item-height: 30px;
                --mdc-icon-size: 16px;
            }

            .menuIcon {
                margin-right: 0.5rem;
                color: var(--theme-lighter-text-color);
            }

            mwc-icon-button {
                color: var(--context-menu-text-color);
                --mdc-icon-button-size: 2.5rem;
            }

            .linkButton {
                cursor: pointer;
                color: var(--main-primary-color);
                margin: 0 1rem;
            }

            .flexContainer {
                display: flex;
                align-items: center;
            }

            .headerIcon {
                margin-right: 2px;
                --mdc-icon-size: 1rem;
            }

            @media screen and (min-width: 901px) {
                .desktopOnly {
                    display: block;
                }

                .mobileOnly {
                    display: none;
                }

                .desktopOnly.flexContainer {
                    display: flex;
                }
            }

            @media screen and (max-width: 900px) {
                .desktopOnly {
                    display: none;
                }

                .mobileOnly {
                    display: flex;
                }

                .mobileOnly.flexContainer {
                    display: flex;
                }
            }
        `;
    }

    learnClick() {
        logWithAmplitude(HelpMenu.amplitude_callsite, 'Proxi Learn Click');
        window.open(`https://learn.proxi.co/`, '_blank');
    }

    blogClick() {
        logWithAmplitude(HelpMenu.amplitude_callsite, 'Proxi Blog Click');
        window.open(`https://proxi.co/blog`);
    }

	visitContactClick() {
        logWithAmplitude(HelpMenu.amplitude_callsite, 'Email Us Click');
        window.location.assign(`mailto:help@proxi.co`);
    }

    submitFeatureRequestClick() {
        logWithAmplitude(HelpMenu.amplitude_callsite, 'Submit Feature Request Click');
        window.open(`https://proxi.sleekplan.app/`, '_blank');
    }

    scheduleDemoClick() {
        logWithAmplitude(HelpMenu.amplitude_callsite, 'Schedule Demo Click');
        window.open(`https://app.proxi.co/demo`, '_blank');
    }
}
